'use strict';

module.exports = getLazyLoadingConfig;

/**
 * getLazyLoadingConfig returns the lazy loading configuration from the page model.
 *
 * @typedef {{
 *      renderMarginPercent: number,
 *      fetchMarginPercent: number,
 *      mobileScaling: number}} LazyLoadingThresholds
 * @typedef {{disabled: boolean, thresholds: LazyLoadingThresholds}} LazyLoadingConfig
 * @returns {LazyLoadingConfig}
 */
function getLazyLoadingConfig() {
    const config = window.phxPageTarget?.config?.global?.config?.lazyLoading;
    return {
        disabled: config?.disabled === true,
        thresholds: {
            renderMarginPercent: config?.thresholds?.renderMarginPercent ?? 75,
            fetchMarginPercent: config?.thresholds?.fetchMarginPercent ?? 200,
            mobileScaling: config?.thresholds?.mobileScaling ?? 3,
        },
    };
}
